var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBucketColor = function SvgBucketColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "bucket-color_svg__a",
    width: 6.9,
    height: 1,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h3.45v1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M3.45 0H6.9v1H3.45z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bucket-color_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 20.4h24V24H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bucket-color_svg__a)",
    d: "M.05 23.95v-3.5h23.9v3.5H0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 20.4h24V24H0z",
    mask: "url(#bucket-color_svg__b)",
    style: {
      fill: "var(--accent)",
      stroke: "var(--accent-stroke)",
      strokeWidth: "var(--accent-stroke-width)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.027 17.724q.57.568 1.38.568.813 0 1.38-.569.57-.569.57-1.38 0-.542-.305-1.119a11 11 0 0 0-.66-1.087 33 33 0 0 0-.475-.632 19 19 0 0 0-.51-.632q-.262.314-.51.632a32 32 0 0 0-.475.632q-.353.51-.659 1.087-.305.577-.305 1.12 0 .81.569 1.38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.594 1.184 6.774 0l9.305 9.305q.587.586.587 1.437 0 .85-.587 1.437l-4.82 4.84q-.576.577-1.426.577t-1.427-.576l-4.819-4.84A1.96 1.96 0 0 1 3 10.741q0-.85.587-1.437l5.066-5.062zm-.855 9.333 5.105-5.083 5.083 5.083a.26.26 0 0 1 .07.113q.015.059.015.123H4.653q0-.065.017-.123a.26.26 0 0 1 .07-.113",
    clipRule: "evenodd"
  })));
};
export default SvgBucketColor;